const {enabled}=require('./transition.js');
const {track:observe,schedule}=require('./scroll-driver.js');
const {timeline,travel,progressAt}=require('./showcase-timeline.js');

document.querySelectorAll('[data-project-showcase]').forEach(sequence=>{
 const rail=sequence.querySelector('[data-showcase-track]');
 const cards=[...sequence.querySelectorAll('[data-showcase-project]')];
 const viewport=sequence.querySelector('.one-projectstrip__viewport');
 const controls=sequence.querySelector('[data-showcase-controls]');
 if(!rail||!controls||cards.length<2)return;
 const pickers=[...sequence.querySelectorAll('[data-showcase-goto]')];
 const previous=sequence.querySelector('[data-showcase-previous]'),next=sequence.querySelector('[data-showcase-next]');
 const counter=sequence.querySelector('[data-showcase-current]'),status=sequence.querySelector('[data-showcase-status]');
 const instruction=sequence.querySelector('[data-showcase-instruction]');
 let mode='flow',current=0,target=0,settling=0,frame=0,settingUp=false,painted=-1;
 const bounded=index=>Math.max(0,Math.min(cards.length-1,index));
 const paint=(position=current,progress=current/(cards.length-1))=>{
  sequence.style.setProperty('--showcase-progress',String(progress));
  if(mode==='pinned')rail.style.setProperty('--showcase-x',`${-position*100}%`);
  cards.forEach((card,index)=>{
   const distance=Math.max(-1,Math.min(1,index-position));
   card.style.setProperty('--case-turn',`${distance*-13}deg`);
   card.style.setProperty('--case-rise',`${Math.abs(distance)*42}px`);
   card.style.setProperty('--case-scale',String(1-Math.abs(distance)*.08));
   card.style.setProperty('--case-phone',`${Math.abs(distance)*70}px`);
  });
 };
 const preload=()=>cards.forEach((card,index)=>{
  if(Math.abs(index-current)>1)return;
  card.querySelectorAll('img').forEach(image=>{if(image.loading!=='eager'){image.loading='eager';image.decode?.().catch(()=>{});}});
 });
 const activate=(index,force=false)=>{
  current=bounded(index);
  if(current===painted&&!force)return;
  painted=current;
  cards.forEach((card,i)=>{card.inert=mode!=='flow'&&i!==current;card.classList.toggle('is-current',i===current);});
  pickers.forEach((button,i)=>{if(i===current)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
  previous.disabled=current===0;next.disabled=current===cards.length-1;
  counter.textContent=String(current+1).padStart(2,'0');
  preload();
 };
 const measureSnap=()=>{
  if(mode!=='snap')return;
  const left=rail.scrollLeft+cards[0].offsetLeft;
  activate(cards.reduce((best,card,i)=>Math.abs(card.offsetLeft-left)<Math.abs(cards[best].offsetLeft-left)?i:best,0));
 };
 const announce=()=>{
  // Instant jumps may dispatch scrollend before the queued measurement frame.
  if(mode==='snap'){cancelAnimationFrame(frame);frame=0;measureSnap();}
  clearTimeout(settling);target=current;
  const message=`Referenz ${current+1} von ${cards.length}: ${cards[current].querySelector('h3').textContent}`;
  if(status.textContent!==message)status.textContent=message;
 };
 const queueAnnouncement=()=>{clearTimeout(settling);settling=setTimeout(announce,180);};
 const align=()=>{if(mode==='snap')rail.scrollTo({left:cards[current].offsetLeft-cards[0].offsetLeft,behavior:'instant'});};
 const go=index=>{
  if(mode==='flow')return;
  target=bounded(index);
  if(mode==='pinned'){
   const start=scrollY+sequence.getBoundingClientRect().top-84;
   window.scrollTo({top:start+travel(innerHeight,cards.length)*target/(cards.length-1),behavior:enabled()?'smooth':'instant'});
  }else{
   rail.scrollTo({left:cards[target].offsetLeft-cards[0].offsetLeft,behavior:enabled()?'smooth':'instant'});
  }
  queueAnnouncement();
 };
 const clearMotion=()=>{
  rail.style.removeProperty('--showcase-x');
  cards.forEach(card=>['--case-turn','--case-rise','--case-scale','--case-phone'].forEach(name=>card.style.removeProperty(name)));
 };
 const setup=()=>{
  if(settingUp)return;
  settingUp=true;
  cancelAnimationFrame(frame);frame=0;clearTimeout(settling);
  const rect=sequence.getBoundingClientRect(),wasVisible=rect.top<=85&&rect.bottom>innerHeight*.5,oldMode=mode;
  const start=scrollY+rect.top-84;
  mode=enabled()&&innerWidth>=1024&&innerHeight>=700?'pinned':innerHeight>=620?'snap':'flow';
  sequence.classList.toggle('is-pinned',mode==='pinned');sequence.classList.toggle('is-snap',mode==='snap');
  sequence.style.setProperty('--showcase-distance',`${travel(innerHeight,cards.length)}px`);
  controls.hidden=mode==='flow';
  clearMotion();
  if(mode==='flow'){
   ['role','aria-roledescription','aria-label','tabindex'].forEach(name=>rail.removeAttribute(name));
   cards.forEach(card=>['role','aria-roledescription','aria-label'].forEach(name=>card.removeAttribute(name)));
  }else{
   rail.setAttribute('role','region');rail.setAttribute('aria-roledescription','Karussell');rail.setAttribute('aria-label','Projektkino: mit Pfeiltasten nach links und rechts wechseln');rail.setAttribute('tabindex','0');
   cards.forEach((card,index)=>{card.setAttribute('role','group');card.setAttribute('aria-roledescription','Folie');card.setAttribute('aria-label',`${index+1} von ${cards.length}`);});
  }
  instruction.textContent=mode==='pinned'?'Weiterscrollen / Projekte erleben':mode==='snap'?'Wischen / Projekte entdecken':'Ausgewählte Referenzen';
  activate(current,true);align();
  if(mode==='pinned')rail.scrollTo({left:0,behavior:'instant'});
  if(wasVisible&&oldMode!=='flow')window.scrollTo({top:mode==='pinned'?start+travel(innerHeight,cards.length)*current/(cards.length-1):Math.max(0,start),behavior:'instant'});
  if(mode==='pinned')paint(current,current/(cards.length-1));
  target=current;settingUp=false;schedule();
 };
 observe(sequence,data=>{
  if(mode!=='pinned')return;
  const state=timeline(progressAt(data.top,data.height,data.viewport),cards.length);
  activate(state.current);paint(state.position,state.progress);queueAnnouncement();
 },()=>({top:sequence.getBoundingClientRect().top,height:sequence.offsetHeight,viewport:viewport.offsetHeight}),clearMotion);
 previous.addEventListener('click',()=>go(target-1));next.addEventListener('click',()=>go(target+1));
 pickers.forEach((button,index)=>button.addEventListener('click',()=>go(index)));
 rail.addEventListener('keydown',event=>{
  if(mode==='flow'||event.altKey||event.ctrlKey||event.metaKey)return;
  const positions={ArrowLeft:target-1,ArrowRight:target+1,Home:0,End:cards.length-1};
  if(!(event.key in positions))return;
  event.preventDefault();
  if(cards.some(card=>card.contains(document.activeElement)))rail.focus({preventScroll:true});
  go(positions[event.key]);
 });
 rail.addEventListener('scroll',()=>{
  if(mode!=='snap')return;
  if(!frame)frame=requestAnimationFrame(()=>{
   frame=0;
   measureSnap();
  });
  queueAnnouncement();
 },{passive:true});
 rail.addEventListener('scrollend',announce);
 addEventListener('resize',setup);
 addEventListener('onestep:motion',setup);
 document.fonts?.ready.then(setup);
 setup();
});
